import { useEffect } from 'react'

export default function useWakeLock(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined

    let lock = null
    let stopped = false

    const keepAwake = async () => {
      if (stopped || lock || document.visibilityState !== 'visible' || !navigator.wakeLock) return
      try {
        lock = await navigator.wakeLock.request('screen')
        lock.addEventListener('release', () => {
          lock = null
          if (!stopped && document.visibilityState === 'visible') keepAwake()
        })
      } catch {
        lock = null
      }
    }

    const onVisible = () => {
      if (document.visibilityState === 'visible') keepAwake()
    }

    keepAwake()
    document.addEventListener('visibilitychange', onVisible)
    document.addEventListener('pointerdown', keepAwake)
    return () => {
      stopped = true
      document.removeEventListener('visibilitychange', onVisible)
      document.removeEventListener('pointerdown', keepAwake)
      lock?.release().catch(() => {})
    }
  }, [enabled])
}
